<template>
    <div>
      <b-card v-if="this.Type == 'C1'">
          <h3>Device ID: {{ this.ID }}</h3>
          <br/>
          <b-row><b-col><p class="small">The tags chosen for the probes are representative of the associated Risk Control Measures.<br/>
          The probe will be assessed against the chosen set of parameters within the Risk Control Measure.<br/>
           This will be used for generating breaches and risk profiles.</p></b-col></b-row>
          <b-row>
            <b-col>C1 Probe Tags</b-col></b-row>
            <b-card-group deck>
         <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{id.ProbeFeed}}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col><b-form-select v-model="id.ProbeTag" :options="tagOptions" size="sm"></b-form-select></b-col></b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
        <b-card v-if="this.Type == 'O1'">
          <h3>Device ID: {{ this.ID }}</h3>
          <br/>
          <b-row><b-col><p class="small">The tags chosen for the probes are representative of the associated Risk Control Measures.<br/>
          The probe will be assessed against the chosen set of parameters within the Risk Control Measure.<br/>
           This will be used for generating breaches and risk profiles.</p></b-col></b-row>
          <b-row>
            <b-col>O1 Probe Tags</b-col></b-row>
          <b-card-group deck>
            <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
             header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{ id.ProbeFeed }}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col><b-form-select v-model="id.ProbeTag" :options="tagOptions" size="sm"></b-form-select></b-col></b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
         <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>
         
        
    </div>
</template>

<script>
    export default {
       props:['DataPass','Type','ID','Feeds','Positions'],
      data() {
      return {
        stepComplete: false,
        tagOptions:[
              {value: 'Hot Outlet', text: 'Hot Outlet'},
              {value: 'Hot Water Return', text: 'Hot Water Return'},
              {value: 'Cold Outlet', text: 'Cold Outlet'},
              {value: 'Cold Water Supply', text: 'Cold Water Supply'},
              {value: 'TMV Hot In', text: 'TMV Hot In'},
              {value: 'TMV Cold In', text: 'TMV Cold In'},
              {value: 'TMV Mixed Out', text: 'TMV Mixed Out'},
              {value: 'Cold Water Storage', text: 'Cold Water Storage'},
              {value: 'Hot Water Storage', text: 'Hot Water Storage'},
              {value: 'Combi Boiler', text: 'Combi Boiler'},
              {value: 'Point of Use Heater', text: 'Point of Use Heater'},
              {value: 'Calorifier', text: 'Calorifier'},
              {value: 'Cooling Tower', text: 'Cooling Tower'},
              {value: 'Custom Thresholds', text: 'Custom Thresholds'}

            ],
            myData: [],
            ProbeArray: [],
            Values:[],
      }
    },
    computed: {},
    components: {},
    methods:{
      CompletePage(){
        let valid = ""
        for(let t=0;t<this.ProbeArray.length;t++){
          if(this.ProbeArray[t].ProbeTag == ""){
            alert("Please select a tag for each probe")
            valid = "false"
          }
        }
        if (valid != 'false'){
          this.Values.push(this.myData[0])
          this.Values.push(this.myData[1])
          this.Values.push(this.myData[2])
          this.Values.push(this.ProbeArray)
          this.$emit("PageComplete",3,this.Values);
          this.stepComplete = true;
        }
      },
    },
    mounted(){
      this.myData = this.DataPass
      
      this.ProbeArray = this.myData[3];
      
    }

    }
</script>

<style>
.TwoWideRepeatDash{
  min-width: 45%; max-width: 100%; margin-bottom: 1rem !important;
}
</style>